import { render } from "./RaceRatingBody.vue?vue&type=template&id=3a6920c3&scoped=true"
import script from "./RaceRatingBody.vue?vue&type=script&lang=js"
export * from "./RaceRatingBody.vue?vue&type=script&lang=js"

import "./RaceRatingBody.vue?vue&type=style&index=0&id=3a6920c3&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6920c3"]])

export default __exports__